import React, { useState, useEffect } from 'react';
import {
    Route, Routes, BrowserRouter, useLocation, useNavigate
} from "react-router-dom";

import { createRoot } from 'react-dom/client';

import { Toast } from "./components/toast";

import './assets/css/style.css'
import Logo from './assets/images/logo.png'

import * as Util from './helpers/util';
import {Landing} from "./pages/landing";
import { Sidebar } from "./components/sidebar";
import { HeaderSearch } from "./components/header_search";
import {Credentials} from "./pages/credentials";
import { Sheets } from "./pages/sheets";


export const App = (props) => {
    const [state, setState] = useState({
        preloaded: true,
        delay_loading: false,
        slow: false,
        err: false,
        toast: { msg: "", status: "" },
    })
    const { preloaded, delay_loading, err, slow, toast } = state

    const handleLoaded = () => {
        setState(prev => ({...prev,
            preloaded: true,
        }))
    }

    const handleToast = ( msg, status ) => {
        if ( status === undefined || status === null ) {
            status = "failure"
        }

        const toast = { msg, status };
        setState(prev => ({ ...prev, toast }))
    }

    const handleToastComplete = () => {
        const toast = { msg: "", status: "" };
        setState(prev => ({ ...prev, toast }))
    }

    //Main entry into program
    return (
        <BrowserRouter>
            <Core
                showToast={handleToast}
            />

            <Toast
                msg={toast.msg}
                status={toast.status}
                timeout={5000}
                onComplete={handleToastComplete}
            />
        </BrowserRouter>
    );
}

export const Preload = (props) => {
    const { msg, showToast, onLoaded } = props

    const path = `${window.location.pathname}`.replace(/^\//, '').replace(/\/.*$/, '').toLowerCase()
    const navigate = useNavigate()

    useEffect(() => {
        onLoaded()
    }, [])

    return (
        <div className="flex flex-col justify-center items-center h-screen bg-white max-w-full max-h-full z-50">
            <img src={Logo} alt="Logo" className="w-1/4"/>
            <p className="text-xl text-red-600">{msg}</p>
        </div>
    )
}

//This odd nesting is required because I need to load the path and that can only happen inside the router
export const Core = (props) => {
    const { showToast } = props

    const location = useLocation()
    const path = `${window.location.pathname}`.replace(/^\//, '').replace(/\/.*$/, '').toLowerCase()

    const [sheet, setSheet] = useState(null)

    useEffect(() => {
        //Title controls
        if ( path === 'landing' || path === '' ) {
            document.title = `Flowster.ai`
        }
        else {
            document.title = `Flowster.ai | ${Util.namify( path )}`
        }
    }, [location])

    const hidden = false
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const search = ""
    const handleSearch = (search) => {
        console.log("Search: ", search)
    }

    const handleSheet = (sheet) => {
        setSheet(sheet)
        if ( path !== 'landing' && path !== '' ) {
            location.pathname = '/'
        }
    }

    return (
        <div>
            <Sidebar
                hidden={hidden}
                sidebarOpen={sidebarOpen}
                onSidebarOpen={setSidebarOpen}
                onTutorial={() => ({})}
                showToast={showToast}
            />

            <div className="lg:pl-52">
                <HeaderSearch
                    search={search}
                    showToast={showToast}
                    onSidebarOpen={setSidebarOpen}
                    onSearch={handleSearch}
                />

                <main className="py-6">
                    {/* <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">*/}
                    <div className="w-full px-4 sm:px-6 lg:px-8">
                        <Routes>
                            <Route path='/credentials' element={
                                <Credentials
                                    showToast={showToast}
                                />
                            }/>
                            <Route path='/sheets' element={
                                <Sheets
                                    onSheet={handleSheet}
                                    showToast={showToast}
                                />
                            }/>
                            <Route path='*' element={
                                <Landing
                                    sheet={sheet}
                                    onSheet={handleSheet}
                                    showToast={showToast} />
                            }/>
                        </Routes>
                    </div>
                </main>
            </div>
        </div>
    );
}

//*** This is the part that inserts the react app into the dom
const app = document.getElementById('app');
const root = createRoot(app);

const csrf = app.getAttribute("csrf");

root.render(
    //<React.StrictMode>
        <App csrf={csrf} />
    //</React.StrictMode>
)
